// SPECULATIVE SHAPE — the GET stationbridge/call-history pull endpoint exists server-side
// (per the cloud bridge), but its RESPONSE shape is NOT in the contract doc. This is the UI's
// proposed shape; the backend session must confirm it and add it to the contract.
export interface CallHistoryEntry {
  id: string
  direction: 'inbound' | 'outbound' | 'internal'
  disposition: 'answered' | 'missed' | 'voicemail'
  peer_name: string
  peer_number: string
  started_at: string // ISO8601
  duration_seconds: number
}

const iso = (minsAgo: number) => new Date(Date.now() - minsAgo * 60_000).toISOString()

export function mockCallHistory(): CallHistoryEntry[] {
  return [
    { id: 'h1', direction: 'inbound', disposition: 'answered', peer_name: 'A. Customer', peer_number: '+14805550199', started_at: iso(12), duration_seconds: 214 },
    { id: 'h2', direction: 'outbound', disposition: 'answered', peer_name: 'Acme Supply (AP)', peer_number: '+18005551234', started_at: iso(38), duration_seconds: 96 },
    { id: 'h3', direction: 'inbound', disposition: 'missed', peer_name: '', peer_number: '+14805550147', started_at: iso(64), duration_seconds: 0 },
    { id: 'h4', direction: 'inbound', disposition: 'voicemail', peer_name: 'Dr. Lin', peer_number: '+14805550182', started_at: iso(120), duration_seconds: 122 },
    { id: 'h5', direction: 'internal', disposition: 'answered', peer_name: 'M. Chen', peer_number: '1043', started_at: iso(180), duration_seconds: 305 },
    { id: 'h6', direction: 'outbound', disposition: 'answered', peer_name: 'City Permits desk', peer_number: '+16025557700', started_at: iso(240), duration_seconds: 410 },
    { id: 'h7', direction: 'inbound', disposition: 'missed', peer_name: 'R. Diaz', peer_number: '+14805550143', started_at: iso(360), duration_seconds: 0 },
    { id: 'h8', direction: 'outbound', disposition: 'answered', peer_name: 'FedEx pickup', peer_number: '+18004633339', started_at: iso(520), duration_seconds: 73 }
  ]
}
